import { useState, useEffect, Fragment } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UILink from 'UIComponents/link/UILink';
import UISelect from 'UIComponents/input/UISelect';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIButton from 'UIComponents/button/UIButton';
import Routes from 'ContentUtils/Routes';
import { fetchCanSpam } from 'ContentData/api/Emails';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.form.formWorkflowDependencies.followupEmailWorkflows.emailEditorPanel.canSpamSettingsId.${key}`;
const FooterSelectItem = ({
  children,
  className,
  option
}) => {
  return /*#__PURE__*/_jsx("span", {
    className: className,
    children: /*#__PURE__*/_jsx(UITooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('optionDisabled')
      }),
      disabled: !option.disabled,
      children: children
    })
  });
};
const Footer = ({
  footer
}) => {
  const {
    company_name,
    company_street_address_1,
    company_street_address_2,
    company_city,
    company_state,
    company_country,
    company_zip,
    company_phone,
    display_name,
    name
  } = footer;
  const address = [company_name, company_street_address_1, company_street_address_2, company_city, company_state, company_country, company_zip, company_phone].filter(_address => _address) // Identity function
  .join(' ');
  return /*#__PURE__*/_jsxs("div", {
    className: "m-top-4",
    children: [display_name ? /*#__PURE__*/_jsx("h5", {
      children: name
    }) : null, /*#__PURE__*/_jsx("div", {
      children: address
    })]
  });
  return /*#__PURE__*/_jsx("div", {
    children: address
  });
};
const FooterSelect = ({
  onChange,
  value
}) => {
  const [emailFooterOptions, setEmailFooterOptions] = useState([]);
  const [showEmailFooterFetchError, setShowEmailFooterFetchError] = useState(false);
  useEffect(() => {
    fetchCanSpam().then(response => {
      const {
        objects
      } = response || {};
      if (objects) {
        setEmailFooterOptions(objects.map(footer => ({
          text: footer.name || I18n.text(i18nKey('defaultFooterName')),
          value: footer.id,
          disabled: footer.is_valid === false,
          footer
        })));
      }
    }).catch(() => setShowEmailFooterFetchError(true));
  }, []);
  const settingsUrl = Routes.settings('email', 'footer');
  if (!emailFooterOptions.length && !showEmailFooterFetchError) {
    return /*#__PURE__*/_jsx("div", {
      className: "m-top-6",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: i18nKey('emptyState_jsx'),
        options: {
          external: true,
          href: settingsUrl
        },
        elements: {
          Link: UILink
        }
      })
    });
  }
  const {
    footer: selectedFooter
  } = emailFooterOptions.find(({
    value: _value
  }) => _value === value) || {};
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(UIFormControl, {
      error: showEmailFooterFetchError,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('label')
      }),
      required: true,
      validationMessage: showEmailFooterFetchError && /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('emailFooterFetchError')
      }),
      children: /*#__PURE__*/_jsxs(UIFlex, {
        children: [/*#__PURE__*/_jsx(UISelect, {
          options: emailFooterOptions,
          placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('placeholder')
          }),
          onChange: e => onChange(e.target.value),
          value: value,
          itemComponent: FooterSelectItem
        }), /*#__PURE__*/_jsx(UIBox, {
          children: /*#__PURE__*/_jsx(UIButton, {
            external: true,
            href: settingsUrl,
            use: "tertiary-light",
            className: "m-left-2",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('manageFooters')
            })
          })
        })]
      })
    }), selectedFooter && /*#__PURE__*/_jsx(Footer, {
      footer: selectedFooter
    })]
  });
};
export default FooterSelect;